var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAremxyPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 19,
    viewBox: "0 0 37 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7922 15.4354H8.39124L9.69524 11.3509H11.4882L10.5102 8.08341H15.8892L19.6382 18.0494H13.8517L12.9552 15.4354H12.7922ZM30.8037 0.322998C34.1452 0.322998 36.8347 3.01872 36.8347 6.36795C36.8347 9.71718 34.1452 12.4129 30.8037 12.4129H27.8697V18.0494H22.4092V8.00172H29.5812C30.4777 8.00172 31.2112 7.26652 31.2112 6.36795C31.2112 5.46937 30.4777 4.73418 29.5812 4.73418H10.3472L6.02774 18.0494H0.322754L6.76124 0.322998H30.8037Z",
    fill: "#04177F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAremxyPlug);
export default __webpack_public_path__ + "static/media/aremxyPlug.9655ce04ca58b65093891b82f070ac9a.svg";
export { ForwardRef as ReactComponent };